import styled from "styled-components";
import { TextBase } from "components";

import { mobile } from "styles/breakpoints";

export const Paragraph = styled(TextBase)<{isTablet?: boolean}>`
  font-size: 1.125rem;
  line-height: 2rem;

  @media ${mobile} {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;

export const ParagraphMobile = styled(TextBase)`
  font-size: 1rem;
  line-height: 1.5rem;
`;